import {
    PRIVATE_CONFIG_LOADED,
} from '../../actions/configuration';

export const defaultState = {
    isShowLastPriceVisible: true,
    isShowRankingVisible: true,
    isShowLimitBidModificationVisible: true,
    maxUploadSizePerFile: 0,
};

const privateConfig = (state = defaultState, action = undefined) => {
    if (action.type === PRIVATE_CONFIG_LOADED) {
        return {
            isShowLastPriceVisible: action.payload.showLastPriceEnabled,
            isShowRankingVisible: action.payload.showBidRankingEnabled,
            isShowLimitBidModificationVisible: action.payload.showLimitBidModificationEnabled,
            maxUploadSizePerFile: action.payload.maxUploadSizePerFile,
        };
    }
    return state;
};

export default privateConfig;
